import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconGroups: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M6.25 2.5h-2.5c-0.688 0-1.25 0.563-1.25 1.25v2.5c0 0.688 0.563 1.25 1.25 1.25h2.5c0.688 0 1.25-0.563 1.25-1.25v-2.5c0-0.688-0.563-1.25-1.25-1.25z"
        fill={fill}
      />
      <path
        d="M13.75 7.5h2.5c0.688 0 1.25-0.563 1.25-1.25v-2.5c0-0.688-0.563-1.25-1.25-1.25h-2.5c-0.688 0-1.25 0.563-1.25 1.25v2.5c0 0.688 0.563 1.25 1.25 1.25zM13.75 3.75h2.5v2.5h-2.5v-2.5z"
        fill={fill}
      />
      <path
        d="M6.25 12.5h-2.5c-0.688 0-1.25 0.563-1.25 1.25v2.5c0 0.688 0.563 1.25 1.25 1.25h2.5c0.688 0 1.25-0.563 1.25-1.25v-2.5c0-0.688-0.563-1.25-1.25-1.25zM6.25 16.25h-2.5v-2.5h2.5v2.5z"
        fill={fill}
      />
      <path
        d="M16.25 12.5h-2.5c-0.688 0-1.25 0.563-1.25 1.25v2.5c0 0.688 0.563 1.25 1.25 1.25h2.5c0.688 0 1.25-0.563 1.25-1.25v-2.5c0-0.688-0.563-1.25-1.25-1.25z"
        fill={fill}
      />
      <path
        d="M17.5 10h-1.25c-1.669 0-3.239-0.65-4.419-1.831s-1.831-2.75-1.831-4.419v-1.25c0-1.375-1.125-2.5-2.5-2.5h-5c-1.375 0-2.5 1.125-2.5 2.5v5c0 1.375 1.125 2.5 2.5 2.5h1.25c1.669 0 3.239 0.65 4.419 1.831s1.831 2.75 1.831 4.419v1.25c0 1.375 1.125 2.5 2.5 2.5h5c1.375 0 2.5-1.125 2.5-2.5v-5c0-1.375-1.125-2.5-2.5-2.5zM18.75 17.5c0 0.331-0.131 0.644-0.368 0.882s-0.551 0.368-0.882 0.368h-5c-0.331 0-0.644-0.131-0.882-0.368s-0.368-0.551-0.368-0.882v-1.25c0-4.142-3.358-7.5-7.5-7.5h-1.25c-0.331 0-0.644-0.131-0.882-0.368s-0.368-0.551-0.368-0.882v-5c0-0.331 0.131-0.644 0.368-0.882s0.551-0.368 0.882-0.368h5c0.331 0 0.644 0.131 0.882 0.368s0.368 0.551 0.368 0.882v1.25c0 4.142 3.358 7.5 7.5 7.5h1.25c0.331 0 0.644 0.131 0.882 0.368s0.368 0.551 0.368 0.882v5z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconGroups;
